import React, { useState, useMemo, useEffect } from "react";
import OrderCard from "./OrderCard";
import { ChevronLeft, ChevronRight, Inbox } from "lucide-react";
import Pagination from "./Pagination";

const OrderGrid = ({ ordering, getOrderStatus }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  // ✅ reset page when data changes (FILTER FIX)
  useEffect(() => {
    setCurrentPage(1);
  }, [ordering]);

  const totalPages = Math.ceil(ordering.length / itemsPerPage);

  const currentOrders = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return ordering.slice(start, start + itemsPerPage);
  }, [ordering, currentPage]);

  // ✅ EMPTY STATE
  if (ordering.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        {/* ICON */}
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gray-100 mb-4">
          <Inbox className="text-gray-400" size={28} />
        </div>

        {/* TITLE */}
        <p className="text-lg font-semibold text-gray-700">No orders yet</p>

        {/* DESCRIPTION */}
        <p className="text-sm text-gray-400 mt-2 max-w-xs">
          Orders will appear here once customers place them
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* GRID */}
      <div className="grid md:grid-cols-3 gap-4">
        {currentOrders.map((order) => (
          <OrderCard
            key={order._id}
            order={order}
            getOrderStatus={getOrderStatus}
          />
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default OrderGrid;
